<mat-expansion-panel class="base-component panel-header">
  <mat-expansion-panel-header class="mat-indicator">
    <a class="title font-color title-size">Responsável | Usuário</a>
  </mat-expansion-panel-header>
  <div class="content font-color" *ngIf="user">
    <p class="font-size">{{ user.name }}</p><br>
    <p><b>Email:</b> {{ user.email }}</p>
    <p><b>Tel:</b> {{ mg.nineExtra(user.mobile) | mask: mg.phoneMask  }}</p><br>
    <p><b>Admin:</b> {{ user.can_see_all ? "Sim":"Não" }}</p>
    <p><b>Verificado:</b> {{ user.is_verified ? "Sim":"Não" }}</p>
  </div>
</mat-expansion-panel>

